export enum INVOICE_STATUS {
  OPEN = 'open',
  PAID = 'paid',
  VOID = 'void',
  PENDING = 'pending',
  UNCOLLECTIBLE = 'uncollectible'
}
